export default __webpack_public_path__ + "static/media/whatsapp_banner_headline_mobile_blue.7f628749.gif";